import { css } from '@linaria/core';
import { defaultColors } from './colors';
import BackgroundColorStyles from './overrides/BackgroundColorStyles';
import BorderStyles from './overrides/BorderStyles';
import ButtonStyles from './overrides/ButtonStyles';
import TypographyStyles from './overrides/TypographyStyles';
import { theme } from './theme';

export const globals = css`
  :global() {
    @font-face {
      font-family: 'Inter';
      src: url('../assets/fonts/inter/Inter-Regular.woff2') format('woff2');
      font-display: swap;
      font-weight: 400;
    }

    @font-face {
      font-family: 'Inter';
      src: url('../assets/fonts/inter/Inter-Light.woff2') format('woff2');
      font-display: swap;
      font-weight: 300;
    }

    @font-face {
      font-family: 'Inter';
      src: url('../assets/fonts/inter/Inter-SemiBold.woff2') format('woff2');
      font-display: swap;
      font-weight: 500;
    }

    @font-face {
      font-family: 'Inter';
      src: url('../assets/fonts/inter/Inter-Bold.woff2') format('woff2');
      font-display: swap;
      font-weight: 600;
    }

    * {
      scroll-margin-top: 95px;

      @media (min-width: 992px) {
        scroll-margin-top: 143px;
      }
    }

    html {
      box-sizing: border-box;
    }

    body {
      font-family: 'Inter';
      ::-webkit-scrollbar {
        background-color: ${theme.common.common.white};
        width: 16px;
      }

      /* background of the scrollbar except button or resizer */
      ::-webkit-scrollbar-track {
        background-color: ${theme.common.common.white};
        box-shadow: inset 0 0 6px ${theme.common.gray[300]};
      }
      ::-webkit-scrollbar-track:hover {
        background-color: #f4f4f4;
      }

      /* scrollbar itself */
      ::-webkit-scrollbar-thumb {
        background-color: #babac0;
        border-radius: 16px;
        border: 5px solid ${theme.common.common.white};
      }
      ::-webkit-scrollbar-thumb:hover {
        background-color: #a0a0a5;
        border: 4px solid #f4f4f4;
      }

      /* set button(top and bottom of the scrollbar) */
      ::-webkit-scrollbar-button {
        display: none;
      }
    }

    .sticky-top {
      z-index: 1000 !important;
    }

    .bg-dark {
      background-color: ${defaultColors.dark} !important;
    }

    .bg-light {
      background-color: ${defaultColors.light} !important;
    }

    body,
    .text-dark,
    .text-body {
      color: ${defaultColors.dark} !important;
    }

    .text-primary {
      color: ${defaultColors.primary} !important;
    }

    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }

    body {
      margin: 0;
    }

    .btn {
      display: inline-flex;
      align-items: center;
      transition: background-color 0.3s linear;

      &:focus-visible {
        outline: currentColor solid 1px;
      }

      > svg {
        position: relative;
      }

      &.action-right {
        > svg {
          position: relative;
        }

        &:hover,
        &:focus {
          > svg {
            left: 0.25rem;
          }
        }
      }
    }

    .opacity-hover {
      &:hover {
        opacity: 0 !important;
      }
    }
    .opacity-25-hover {
      &:hover {
        opacity: 0.25 !important;
      }
    }
    .opacity-50-hover {
      &:hover {
        opacity: 0.5 !important;
      }
    }
    .opacity-75-hover {
      &:hover {
        opacity: 0.75 !important;
      }
    }
    .opacity-100-hover {
      &:hover {
        opacity: 1 !important;
      }
    }

    .btn:focus,
    .btn:active:focus {
      box-shadow: none;
    }

    ${TypographyStyles}

    ${BackgroundColorStyles}

    ${ButtonStyles}

    ${BorderStyles}
    
    // Tabs
    .nav-tabs {
      border: none;
      position: relative;
      .nav-item {
        margin-right: 0.375rem;
        &:last-child {
          margin: 0;
        }
        .nav-link {
          background-color: #f6f7fb;
          border-color: #f6f7fb;
          border-width: 0 0 2px 0;
          margin: 0;
          &.active {
            border-color: #000000;
          }
        }
      }
      &::before {
        background-color: #e4e9f4;
        bottom: 0;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        width: 100%;
        z-index: -1;
      }
    }

    .accordion-item {
      border-radius: 0 !important;
      border-inline: 0 !important;
    }

    .accordion-button {
      justify-content: space-between;
    }
    .accordion-button::after {
      margin-left: 1rem;
    }

    // Font sizes
    .fs-xx-small {
      font-size: 10px;
    }
    .fs-x-small {
      font-size: 12px;
    }
    .fs-small {
      font-size: 14px;
    }
    .fs-base {
      font-size: 1rem;
    }
    .fs-large {
      font-size: 18px;
    }
    .fs-x-large {
      font-size: 22px;
    }
    .fs-xx-large {
      font-size: 24px;
    }
    .fs-xxx-large {
      font-size: 26px;
    }

    .pagination-lg .page-link {
      font-size: 1rem;
      color: #2553f8;
      padding: 0.5rem 0.75rem;

      @media screen and (min-width: 480px) {
        padding: 0.75rem 1.25rem;
      }
    }

    .page-item.active .page-link {
      background-color: #e3e7f2;
      border-color: #e3e7f2;
      color: #2b2b2b;
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }

    @media (min-width: 1680px) {
      .container,
      .container-lg,
      .container-md,
      .container-sm,
      .container-xl,
      .container-xxl {
        max-width: 1600px;
      }
    }

    #cc-shoppablelp-root > div > div {
      max-height: none !important;
    }
  }
`;
